import React, { FC, memo } from 'react';
import { BreadcrumbsJp } from '../../breadcrumbs/breadcrumbs';
import { ComponentSwitcher } from '../../shared/component-switcher';
import { MuiTabs } from '../../shared/mui/mui-tabs';
import { Full } from '../../shared/styled/full';
import { ModelList } from '../model-list/model-list';
import { ProjectList } from '../project-list/project-list';

interface Props {
  tabIndex: number;
  tabIndexChange: (idx: number) => void;
  tabs: { label: string; disabled: boolean }[];
  koumutenId: number;
  companyId: number;
}

export const CompanyRootView: FC<Props> = memo(
  ({
    tabIndex,
    tabIndexChange,
    tabs,
    koumutenId,
    companyId
  }: Readonly<Props>) => (
    <Full>
      <BreadcrumbsJp showPadding={true} />
      <MuiTabs
        tabs={tabs}
        index={tabIndex}
        indexChange={tabIndexChange}
        disableRipple={true}
        disableFocusRipple={true}
      />
      <ComponentSwitcher index={tabIndex}>
        <ProjectList koumutenId={koumutenId} companyId={companyId} />
        <ModelList koumutenId={koumutenId} companyId={companyId} />
      </ComponentSwitcher>
    </Full>
  )
);

CompanyRootView.displayName = 'CompanyRootView';
